// extracted by mini-css-extract-plugin
export default {"label":"public-listing-POIFeature__label--2gmA0","icon":"public-listing-POIFeature__icon--3iKrg","container":"public-listing-POIFeature__container--1twuY"};